import React, { useEffect, useState, useRef, useMemo } from "react";
import axios from "axios";

import { useParams, Link } from "react-router-dom";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import jsPDF from "jspdf";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import moment from "moment";
import * as XLSX from "xlsx";
import { toastError, toastSuccess } from "../../../common/Toast";
import { DATA_EXPORT, ERROR_MESSAGE } from "../../../common/Constant";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";

//--------Material React Table------//
import { MaterialReactTable } from "material-react-table";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const currentDate = new Date();
const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
const month = monthNames[currentDate.getMonth()]; // add 1 to get month value from 1 to 12
const hours = currentDate.getUTCHours();
const minutes = currentDate.getUTCMinutes();

const VendorContactList = (props) => {
  const token = localStorage.getItem("Token");
  const [formValues, setFormValues] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalSum, setTotalSum] = useState(0);
  const [groupbycolumn, setGroupbyColumn] = useState([]);
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [activeAccordion, setActiveAccordion] = useState(null);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [totalRows, setTotalRows] = useState(0);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const ITEMS_PER_PAGE = 10;

  const barcodeRefs = useRef([]);
  let index = 0;
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  //Function to generate barcode
  const generateBarcodes = () => {
    barcodeRefs.current.forEach((barcodeRef, index) => {
      console.log("barcodeRefs", barcodeRefs);
      var g = document.getElementsByTagName(barcodeRef);
      const barcodeValue = paramObject.id;
      console.log("barcodeValue", barcodeValue);
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        width: data.width,
        height: data.height,
        fontSize: data.fontSize,
        displayValue: true,
        fontoptions: "bold",
        textAlign: "center",
        font: "monospace",
        textPosition: "bottom",
        textMargin: 2,
        margin: 10,
        marginTop: undefined,
        marginBottom: undefined,
        marginLeft: undefined,
        marginRight: undefined,
        format: "CODE128",
        valid: () => true,
        background: "#ffffff",
        lineColor: "#000000",
        padding: data.zeroFill,
      });
    });
  };

  //Function for downloading pdf of barcodesheet
  const downloadPdf = () => {
    const pdf = new jsPDF();
    responseData.forEach((item) => {
      // Generate barcode for the current item
      const barcodeRef = barcodeRefs.current[item.SaleId];
      const barcodeValue = `${item.SaleId}`;
      const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
      JsBarcode(barcodeRef, paddedBarcodeValue, {
        // barcode options
      });

      // Add barcode to PDF
      const canvas = barcodeRef;
      const imgData = canvas.toDataURL("image/png");
      pdf.addImage(imgData, "PNG", 10, 10);
      pdf.addPage();
    });
    pdf.deletePage(responseData.length + 1); // Remove extra page added by addPage() method
    pdf.save("barcodes.pdf");
  };

  const downloadPDF = (rows, field) => {
    let newData = [];
    if (field === "selectedrow") {
      newData = rows.map((row) => row.original);
    } else if (field === "alldata") {
      newData = responseData;
    }
    console.log(newData, "newData");

    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.marginLeft = "15rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 15;

    for (var i = 1; i <= Math.ceil(newData.length / 15); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "19rem";
      }
      // Printing header
      content += " " + clonedHeader.outerHTML;

      // Printing table body
      content +=
        '<table style="font-size: 8px; margin-left: 2rem; margin-top: 2rem; width: 1140px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 7px;">No</th>' +
        '<th style="padding: 7px;">VENDOR</th>' +
        '<th style="padding: 7px;">PhoneNumber</th>' +
        '<th style="padding: 7px; ">Email</th>' +
        '<th style="padding: 7px;">ADDRESS</th>' +
        // '<th style="padding: 7px;">Num</th>' +
        // '<th style="padding: 7px; ">Amount</th>' +
        // '<th style="padding: 7px;">OpenBalance</th>' +
        // '<th style="padding: 7px; ">ModifiedDate</th>' +
        // '<th style="padding: 7px;">CreatedBy</th>' +
        // '<th style="padding: 7px;">CreatedDate</th>' +
        // '<th style="padding: 7px; ">ModifiedBy</th>' +
        // '<th style="padding: 7px;">Split</th>' +
        // '<th style="padding: 7px; ">DueDate</th>' +
        // '<th style="padding: 7px;">Account</th>' +
        // '<th style="padding: 7px;">VendorMessage</th>' +
        // '<th style="padding: 7px; ">Terms</th>' +
        // '<th style="padding: 7px;">Payment Method</th>' +
        // '<th style="padding: 7px;">Customer ID</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= newData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].Supplier +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].PhoneNumber +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px; ">' +
            newData[index - 1].Email +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].ShippingAddress +
            "</td>" +
            // '<td style="font-size: 7px; padding: 7px;">' +
            // newData[index - 1].Num +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px; ">' +
            // Number(newData[index - 1].Amount).toFixed(2) +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px; ">' +
            // newData[index - 1].OpenBalance +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px;">' +
            // moment(newData[index - 1].ModifiedDate).format('DD-MM-YYYY') +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px;">' +
            // newData[index - 1].CreatedBy +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px;">' +
            // moment(newData[index - 1].CreatedDate).format('DD-MM-YYYY') +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px; ">' +
            // newData[index - 1].ModifiedBy +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px; ">' +
            // newData[index - 1].Split +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px;">' +
            // moment(newData[index - 1].DueDate).format('DD-MM-YYYY') +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px;">' +
            // newData[index - 1].Account +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px; ">' +
            // newData[index - 1].VendorMessage +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px; ">' +
            // newData[index - 1].Terms +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px; ">' +
            // newData[index - 1].PaymentMethod +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px; ">' +
            // newData[index - 1].CustomerID +
            // '<td style="font-size: 7px; padding: 7px; ">' +
            // Number(data[index - 1].Balance).toFixed(2) +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px; text-align: right;">' +
            // Number(data[index - 1].Amount).toFixed(2) +
            // "</td>" +
            // '<td style="font-size: 7px; padding: 7px; ">' +
            // Number(data[index - 1].Balance).toFixed(2) +
            // "</td>" +
            "</tr>";
        }

        if (index % 15 == 0) {
          startIndex = startIndex + 15;
          endIndex = endIndex + 15;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      // content +=
      //   '<div style="text-align: center; width: 560px;  margin-left: 220px">' +
      //   '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
      //   i +
      //   "</p>" +
      //   "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("Vendor_Contact_List.pdf");
        setLoading(false);
      },
    });
  };
  //Function for print
  const handlePrint = async () => {
    const pages = document.querySelectorAll("#print");
    const pdf = new jsPDF();

    const input = pages[0];
    const width = input.offsetWidth;
    const height = input.offsetHeight;

    const imgData = await html2canvas(input, { width, height }).then((canvas) =>
      canvas.toDataURL("image/png")
    );

    pdf.addImage(
      imgData,
      "JPEG",
      0,
      0,
      pdf.internal.pageSize.width,
      pdf.internal.pageSize.height
    );

    for (let i = 1; i < pages.length; i++) {
      const input = pages[i];
      const width = input.offsetWidth;
      const height = input.offsetHeight;

      const imgData = await html2canvas(input, { width, height }).then(
        (canvas) => canvas.toDataURL("image/png")
      );

      pdf.addPage();
      pdf.addImage(
        imgData,
        "JPEG",
        0,
        0,
        pdf.internal.pageSize.width,
        pdf.internal.pageSize.height
      );
    }

    // Convert the PDF to a Blob object
    const pdfBlob = pdf.output("blob");

    // Create a URL for the Blob object
    const pdfUrl = URL.createObjectURL(pdfBlob);

    // Open a new window with the URL
    const printWindow = window.open(pdfUrl);

    // Wait for the window to load and then print the PDF
    printWindow.addEventListener("load", () => {
      printWindow.print();
    });
  };

  //Function for download
  const handleDownload = async () => {
    const pages = document.querySelectorAll("#print");
    const pdf = new jsPDF();

    const input = pages[0];
    const width = input.offsetWidth;
    const height = input.offsetHeight;

    const imgData = await html2canvas(input, { width, height }).then((canvas) =>
      canvas.toDataURL("image/png")
    );

    pdf.addImage(
      imgData,
      "JPEG",
      0,
      0,
      pdf.internal.pageSize.width,
      pdf.internal.pageSize.height
    );

    for (let i = 1; i < pages.length; i++) {
      const input = pages[i];
      const width = input.offsetWidth;
      const height = input.offsetHeight;

      const imgData = await html2canvas(input, { width, height }).then(
        (canvas) => canvas.toDataURL("image/png")
      );

      pdf.addPage();
      pdf.addImage(
        imgData,
        "JPEG",
        0,
        0,
        pdf.internal.pageSize.width,
        pdf.internal.pageSize.height
      );
    }

    pdf.save("document.pdf");
  };

  const columns = useMemo(() => [
    {
      header: "VENDOR",
      accessorKey: "Supplier",
    },
    {
      header: "Phone Number",
      accessorKey: "PhoneNumber",
      // Cell: ({ row }) => moment(row.original.Date).format('DD-MM-YYYY'),
    },
    {
      header: "EMAIL",
      accessorKey: "Email",
    },
    {
      header: "ADDRESS",
      accessorKey: "ShippingAddress",
    },
  ]);
  //Function for lookup receipt
  const paramObject = useParams();

  const apicall = () => {
    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );
    console.log(
      JSON.stringify(columnFilters) + " columnFilters | ",
      globalFilter + " globalFilter | ",
      pagination.pageIndex + " pagination.pageIndex | ",
      pagination.pageSize + " pagination.pageSize | ",
      columnIndex,
      sorting[0]?.id,
      sorting[0]?.desc === undefined
        ? "desc"
        : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
      startdate + " startdate | ",
      enddate + " enddate",
      "api Call payload"
    );

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/vendorcontactlist?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&pagesize=${
          pagination.pageSize
        }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
          globalFilter === undefined ? "" : globalFilter
        }&startdate=${startdate}&enddate=${enddate}&groupbycolumn=${selectedOption}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setSelectedOption(res.data.ResponseData);
          setRowCount(res.data.ResponseData[0].TotalRecord);

          console.log("11", responseData);
          //   barcodeRefs.current = responseData;
        }

        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    apicall();
  }, [
    columnFilters,
    globalFilter,
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
  ]);

  useEffect(() => {
    generateBarcodes();
    console.log("barcodeRefs", barcodeRefs);
    // setLoading(true);
    axios
      .get(
        `${
          config.reportsBaseUrl
        }/reports/vendorcontactlist?groupbycolumn=${""}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log("res======>", res);
        console.log(res.data.ResponseData);
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          setSelectedOption(res.data.ResponseData);
          console.log("11", responseData);
          //   barcodeRefs.current = responseData;
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, []);

  const handleExportRows = (rows) => {
    console.log(
      rows.map((row) => row.original),
      "selected row"
    );
    // csvExporter.generateCsv(rows.map((row) => row.original));

    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `VendorContactList_.xlsx`);
  };

  const onBtExport = () => {
    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(responseData);
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `VendorContactList_.xlsx`);
  };

  //Function for export excel
  const handleExcelExport = () => {
    setLoading(true);
    axios
      .post(
        `${config.salesconfigBaseUrl}/sales/excelexport`,
        {
          salesid: paramObject.id,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res);
        toastSuccess(DATA_EXPORT);
        setLoading(false);
      })
      .catch((err) => {
        toastError(ERROR_MESSAGE);
        setLoading(false);
      });
  };

  // to calculate the total
  const calculateTotalSum = () => {
    const sum = responseData.reduce((total, report) => {
      const reportTotal = Number(report.Openingbalance);

      if (typeof reportTotal === "number" && !isNaN(reportTotal)) {
        return total + reportTotal;
      } else {
        return total;
      }
    }, 0);

    setTotalSum(sum);
  };

  const toggleAccordion = (index) => {
    setActiveAccordion(activeAccordion === index ? null : index);
  };

  const renderAccordionIcon = (index) => {
    if (activeAccordion === index) {
      return <FontAwesomeIcon icon={faChevronUp} />;
    } else {
      return <FontAwesomeIcon icon={faChevronDown} />;
    }
  };

  useEffect(() => {
    calculateTotalSum();
  }, [responseData]);

  const totalPages = Math.ceil(responseData.length / ITEMS_PER_PAGE);
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row" style={{ marginTop: "5px" }}>
              <h3 className="page-title">Vendor Contact List</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/report">Report</Link>
                </li>
                <li className="breadcrumb-item active">Vendor Contact List</li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4 mt-4">
              <div className="form-group row">
                <label className="col-form-label col-md-3 form-label">
                  Group by
                </label>
                <div className="col-md-9">
                  <select
                    className="form-control custom-search-select"
                    name="groupby"
                    id="groupby"
                    value={selectedOption}
                    onChange={(e) => setSelectedOption(e.target.value)}
                  >
                    option
                    <option value="">None</option>
                    <option value="CITY">City</option>
                    <option value="STATE">State</option>
                    <option value="ZIP">Zip</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div style={{ display: "flex" }}>
            <button
              type="submit"
              className="btn btn-sm btn-primary pull-right mb-3 w-25 mt-0"
              style={{ marginLeft: "auto" }}
              onClick={apicall}
            >
              Generate Report
            </button>
          </div>

          {/* Receipt */}

          <div className="card mt-5" id="print">
            <div className="card-body">
              <div className="container">
                <div className="col-md-12 text-center" id="header">
                  <h2>SonarPos</h2>
                  <p className="fw-bold">Vendor Contact List</p>
                  {/* <div className="row mb-2">
                    <h6> Date: {new Date().toLocaleDateString()}</h6>
                  </div> */}
                </div>
              </div>
              <hr />
              <div className="table-responsive">
                {/* <table className="table mt-3">
                  <thead className="border 1px solid white">
                    <tr>
                      <th>VENDOR</th>
                      <th>PHONE NUMBERS</th>
                      <th>EMAIL</th>
                      <th>FULL NAME</th>
                      <th>ADDRESS</th>
                      <th>ACCOUNT</th>
                    </tr>
                  </thead>
                  <tbody>
                    {responseData?.map((report, index) => {
                      return (
                        <React.Fragment key={index}>
                          <tr onClick={() => toggleAccordion(index)}>
                            <td colSpan="6">
                              {renderAccordionIcon(index)} &nbsp;
                              {report.Supplier ? report.Supplier : report.ShippingAddress}
                            </td>
                          </tr>
                          {activeAccordion === index && (
                            <tr>
                              <td>{report.Supplier}</td>
                              <td>{report.PhoneNumber}</td>
                              <td>{report.Email}</td>
                              <td>{report.Terms}</td>
                              <td>{report.ShippingAddress}</td>
                              <td>{report.OpenBalance}</td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table> */}

                <MaterialReactTable
                  muiTableContainerProps={{
                    sx: { maxHeight: "fit-content" },
                  }}
                  columns={columns}
                  data={responseData}
                  enableColumnResizing
                  enableGrouping
                  enableStickyHeader
                  enableStickyFooter
                  enableRowSelection
                  enableColumnOrdering
                  initialState={{
                    density: "compact",
                    expanded: true, //expand all groups by default
                    // grouping: [""], //an array of columns to group by by default (can be multiple)
                    pagination: { pageIndex: 0, pageSize: 25 },
                    sorting: [{ id: "state", desc: false }], //sort by state by default
                  }}
                  // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                  // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
                  muiTablePaginationProps={{
                    rowsPerPageOptions: [25, 50, 100, 300, 500],
                  }}
                  // manualFiltering
                  manualPagination
                  manualSorting
                  muiToolbarAlertBannerProps={
                    isError
                      ? {
                          color: "error",
                          children: "Error loading data",
                        }
                      : undefined
                  }
                  // onColumnFiltersChange={setColumnFilters}
                  onGlobalFilterChange={setGlobalFilter}
                  onPaginationChange={setPagination}
                  onSortingChange={setSorting}
                  rowCount={rowCount}
                  state={{
                    // columnFilters,
                    globalFilter,
                    isLoading,
                    pagination,
                    showAlertBanner: isError,
                    showProgressBars: isRefetching,
                    sorting,
                  }}
                  renderTopToolbarCustomActions={({ table }) => (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "1rem",
                        p: "0.5rem",
                        flexWrap: "wrap",
                      }}
                    >
                      <Button
                        size="small"
                        color="primary"
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={onBtExport}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export All In Excel
                      </Button>
                      <Button
                        size="small"
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        onClick={() =>
                          handleExportRows(table.getSelectedRowModel().rows)
                        }
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export Selected Rows in Excel
                      </Button>
                      <Button
                        size="small"
                        color="primary"
                        //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                        onClick={() => downloadPDF("", "alldata")}
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export All In Pdf
                      </Button>
                      <Button
                        size="small"
                        disabled={
                          !table.getIsSomeRowsSelected() &&
                          !table.getIsAllRowsSelected()
                        }
                        //only export selected rows
                        onClick={() =>
                          downloadPDF(
                            table.getSelectedRowModel().rows,
                            "selectedrow"
                          )
                        }
                        startIcon={<FileDownloadIcon />}
                        variant="contained"
                      >
                        Export Selected Rows in Pdf
                      </Button>
                      {/* <Button
                        size="small"
                        onClick={() =>
                          // setPagination({ ...pagination, pageSize: totalRows })
                          setPagination({
                            ...pagination,
                            pageIndex: 0,
                            pageSize: rowCount,
                          })
                        }
                        variant="contained"
                      >
                        Get All Data
                      </Button> */}
                    </Box>
                  )}
                />
              </div>
              <div className="row">
                <div className="col-md-12 text-center">
                  {/* <h6>
                    {" "}
                    {currentDate.toLocaleString()} &nbsp;GMT Time: {hours}:
                    {minutes}
                  </h6> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: "none" }}>
        {responseData.map((item) => (
          <>
            {/* <button onClick={console.log("item", item)}>click me</button> */}
            <div key={item.SaleId}>
              <canvas
                data-name={item.SaleId}
                ref={(el) => (barcodeRefs.current[item.SaleId] = el)}
                id={`barcode-${item.SaleId}`}
              />
            </div>
          </>
        ))}
      </div>
    </>
  );
};

export default VendorContactList;
